import React, { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { authUserSelector } from '~redux/auth/selectors/authUser';
import {
  selectIsProductSearching,
  selectProductListFilters,
  selectProductListPage,
  selectProductListSortType,
} from '~redux/search/product';
import InventoryProvider from '~view/widgets/InventoryProvider';
import ProductListViewItem from '~view/widgets/ProductListViewItem';
import { ProductListViewItemByAlgolia } from '~view/widgets/ProductListViewItemByAlgolia';
import ProductSearchPagination from '~view/widgets/ProductSearchPagination';
import {
  useProductSearchSelector,
  useSelectProducts,
} from '~view/widgets/ProductSearchProvider';
import SaleProducts from '~view/widgets/SaleProducts';

type ListProps = {
  categories?: string[];
  listId: string;
};

const List: React.FC<ListProps> = React.memo(({ categories, listId }) => {
  const auth = useSelector(authUserSelector);

  const listRef = useRef<HTMLDivElement>(null);

  const products = useSelectProducts(listId);
  const isLoading = useProductSearchSelector(selectIsProductSearching, listId);

  const scrollToTop = useCallback(() => {
    if (!listRef?.current) {
      return;
    }
    listRef.current.scrollIntoView({ block: 'center' });
  }, [listRef]);

  const filter = useProductSearchSelector(selectProductListFilters, listId);
  const sort = useProductSearchSelector(selectProductListSortType, listId);
  const page = useProductSearchSelector(selectProductListPage, listId);
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      return;
    }
    scrollToTop();
  }, [JSON.stringify(filter), sort, page]);

  return (
    <>
      <div ref={listRef} />
      <Row xs="2" sm="2" md="3" lg="4" xl="5">
        {!isLoading && !!products?.length && (
          <InventoryProvider
            productIds={products?.map((product) => product.id!) ?? []}
          >
            {products?.map((product, index) => (
              <>
                {auth && index === 10 && page === 1 && (
                  <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <SaleProducts categories={categories ?? []} />
                  </Col>
                )}
                {/* {index === 15 && (
            <Col
              xs="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              className="mb-5 px-2"
            >
              {
                <div className="list-benefits p-6 bg-orange h-100 rounded-0 border-0 d-flex flex-column justify-content-center align-items-center">
                  <h3 className="font-weight-bold">
                    初回購入ブランドは{SERVICE_NAME}へ返品できます。
                  </h3>
                  <p>お支払いは60日後でリスクの低い仕入れが可能です！</p>
                  <div>
                    <a
                      href="https://blog.homula.jp/help/buyers/%E8%BF%94%E5%93%81%E3%81%AE%E4%BB%95%E7%B5%84%E3%81%BF-0"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="bg-white text-dark mr-2 mb-2">
                        返品についての詳細を見る
                      </Button>
                    </a>
                    <a
                      href="https://blog.homula.jp/homula%E5%B0%8E%E5%85%A5%E3%82%B7%E3%83%A7%E3%83%83%E3%83%97-/-wonder-vision%E6%9C%A8%E6%9D%91%E6%B0%8F?hsLang=ja-jp"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="mr-2 mb-2">活用事例を見る</Button>
                    </a>
                  </div>
                </div>
              }
            </Col>
          )} */}
                <ProductListViewItemByAlgolia
                  key={product.id}
                  productJson={product}
                  index={index}
                  border
                />
              </>
            ))}
          </InventoryProvider>
        )}
        {isLoading && [...Array(20)].map(() => <ProductListViewItem border />)}
      </Row>
      <div>
        <ProductSearchPagination listId={listId} />
      </div>
    </>
  );
});

export default List;
